<template>
    <div>
        <div class="col-md-12" v-if="claims.tasks.create">
            <button type="button" class="btn btn-primary m-0" data-toggle="modal"
                    data-target="#createModal">{{ $t("coordinations.newCoordination") }}
            </button>
        </div>
        <tabs
            :options="{ useUrlFragment: false, loadSavedTab: false }" cache-lifetime="10"
            class="m-0"
        >
            <tab id="assignedToMeTab" :name="$t('coordinations.assignedToMe')">
                <div class="grid-wrapper">
                    <kendo-datasource
                        ref="datasource1"
                        :transport="assignedToMeTransportSettings"
                        :schema-model-id="'id'"
                        :schema-total="'total'"
                        :schema-data="'data'"
                        :page-size="defaultGridRows"
                        :server-paging="true"
                        :server-sorting="true"
                        :server-filtering="true"
                        :change="onChange"
                    ></kendo-datasource>
                    <kendo-grid
                        ref="assignedToMeGrid"
                        :data-source-ref="'datasource1'"
                        :sortable="true"
                        :filterable="true"
                        :pageable="gridOptions.pageable"
                        :dataBound="onDatabound"
                        :no-records-template="$t('noData')"
                        :no-records="true"
                    >
                        <kendo-grid-column :field="'id'" :title="'Id'" :width="100" :lockable="true"
                                            :locked="false"></kendo-grid-column>
                        <kendo-grid-column :field="'title'" :title="$t('coordinations.title')" :width="300"
                                            :lockable="true" :locked="false"></kendo-grid-column>
                        <kendo-grid-column :field="'status'" :title="$t('tasks.status')" :width="200"
                                            :lockable="true" :locked="false"></kendo-grid-column>
                        <kendo-grid-column
                            :field="'coordinatorsAsString'"
                            :title="
                                $t('coordinations.coordinators')
                            "
                            :width="200"
                            :lockable="true"
                            :locked="false"
                        ></kendo-grid-column>
                        <kendo-grid-column :field="'deadline'" :title="$t('tasks.deadline')" :width="200"
                                            :lockable="true" :locked="false"
                                            :format="'{0:dd.MM.yyyy H:mm}'"></kendo-grid-column>
                        <kendo-grid-column :field="'type'" :title="$t('coordinations.type')" :width="200"
                                            :lockable="true" :locked="false"></kendo-grid-column>
                        <kendo-grid-column :template="assignToMeBtnsTemplate" :width="150"
                                            :filterable="false" :title="$t('actions')"></kendo-grid-column>
                    </kendo-grid>
                </div>
            </tab>
            <tab id="createdByMeTab" :name="$t('coordinations.createdByMe')">
                <div class="grid-wrapper">
                    <kendo-datasource
                        ref="datasource2"
                        :transport="createdByMeTransportSettings"
                        :schema-model-id="'id'"
                        :schema-total="'total'"
                        :schema-data="'data'"
                        :page-size="defaultGridRows"
                        :server-paging="true"
                        :server-sorting="true"
                        :server-filtering="true"
                        :change="onChange"
                    ></kendo-datasource>
                    <kendo-grid ref="createdByMeGrid"
                                :data-source-ref="'datasource2'"
                                :editable="gridOptions.editable"
                                :filterable="gridOptions.filterable"
                                :pageable="gridOptions.pageable"
                                :reorderable="gridOptions.reorderable"
                                :resizable="gridOptions.resizable"
                                :groupable="gridOptions.groupable"
                                :allow-copy="gridOptions.allowCopy"
                                :column-menu="gridOptions.columnMenu"
                                :sortable-mode="gridOptions.sortable.mode"
                                :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                                :sortable-show-indexes="gridOptions.sortable.showIndexes"
                                :selectable="gridOptions.selectable"
                                :scrollable="gridOptions.scrollable"
                                :dataBound="onDatabound">
                        <kendo-grid-column :field="'id'" :title="'Id'" :width="100" :lockable="true"
                                            :locked="false"></kendo-grid-column>
                        <kendo-grid-column :field="'title'" :title="$t('coordinations.title')" :width="300"
                                            :lockable="true" :locked="false"></kendo-grid-column>
                        <kendo-grid-column :field="'status'" :title="$t('tasks.status')" :width="200"
                                            :lockable="true" :locked="false"></kendo-grid-column>
                        <kendo-grid-column
                            :field="'coordinatorsAsString'"
                            :title="
                                $t('coordinations.coordinators')
                            "
                            :width="200"
                            :lockable="true"
                            :locked="false"
                        ></kendo-grid-column>
                        <kendo-grid-column :field="'deadline'" :title="$t('tasks.deadline')" :width="200"
                                            :lockable="true" :locked="false"
                                            :format="'{0:dd.MM.yyyy H:mm}'"></kendo-grid-column>
                        <kendo-grid-column :field="'type'" :title="$t('coordinations.type')" :width="200"
                                            :lockable="true" :locked="false"></kendo-grid-column>
                        <kendo-grid-column :template="btnsTemplate" :width="150" field="btnsColumn"
                                            :title="$t('actions')" :filterable="false"></kendo-grid-column>
                    </kendo-grid>
                </div>
            </tab>
            <tab id="agreedByMeTab" :name="$t('coordinations.agreedByMe')">
                <div class="grid-wrapper">
                    <kendo-datasource
                        ref="datasource3"
                        :transport="agreedByMeTransportSettings"
                        :schema-model-id="'id'"
                        :schema-total="'total'"
                        :schema-data="'data'"
                        :page-size="defaultGridRows"
                        :server-paging="true"
                        :server-sorting="true"
                        :server-filtering="true"
                        :change="onChange"
                    ></kendo-datasource>
                    <kendo-grid ref="agreedByMeGrid"
                                :data-source-ref="'datasource3'"
                                :editable="gridOptions.editable"
                                :filterable="gridOptions.filterable"
                                :pageable="gridOptions.pageable"
                                :reorderable="gridOptions.reorderable"
                                :resizable="gridOptions.resizable"
                                :groupable="gridOptions.groupable"
                                :allow-copy="gridOptions.allowCopy"
                                :column-menu="gridOptions.columnMenu"
                                :sortable-mode="gridOptions.sortable.mode"
                                :sortable-allow-unsort="gridOptions.sortable.allowUnsort"
                                :sortable-show-indexes="gridOptions.sortable.showIndexes"
                                :selectable="gridOptions.selectable"
                                :scrollable="gridOptions.scrollable"
                                :dataBound="onDatabound">
                        <kendo-grid-column :field="'id'" :title="'Id'" :width="100" :lockable="true"
                                            :locked="false"></kendo-grid-column>
                        <kendo-grid-column :field="'title'" :title="$t('coordinations.title')" :width="300"
                                            :lockable="true" :locked="false"></kendo-grid-column>
                        <kendo-grid-column :field="'status'" :title="$t('tasks.status')" :width="200"
                                            :lockable="true" :locked="false"></kendo-grid-column>
                        <kendo-grid-column
                            :field="'coordinatorsAsString'"
                            :title="
                                $t('coordinations.coordinators')
                            "
                            :width="200"
                            :lockable="true"
                            :locked="false"
                        ></kendo-grid-column>
                        <kendo-grid-column :field="'deadline'" :title="$t('tasks.deadline')" :width="200"
                                            :lockable="true" :locked="false"
                                            :format="'{0:dd.MM.yyyy H:mm}'"></kendo-grid-column>
                        <kendo-grid-column :field="'type'" :title="$t('coordinations.type')" :width="200"
                                            :lockable="true" :locked="false"></kendo-grid-column>
                        <kendo-grid-column :template="agreedToMeBtnsTemplate" :width="150" field="btnsColumn"
                                            :title="$t('actions')" :filterable="false"></kendo-grid-column>
                    </kendo-grid>
                </div>
            </tab>
        </tabs>
        <CreateSignatureModal @onClose="onModalClose" :coordination-id="activeItemId" :show="showCreateSignatureModal" @updated="refresh"></CreateSignatureModal>
        <CreateModal @onClose="onModalClose" @updated="refresh"></CreateModal>
        <EditModal v-model="activeItem" :show.sync="showEdit" @onClose="onModalClose" @updated="refresh"></EditModal>
        <DisplayModal v-model="activeItem" :show.sync="showDisplay" @onClose="onModalClose"
                      @updated="refresh"></DisplayModal>
        <AnswerModal v-model="activeItem" :show.sync="showAnswer" @onClose="onModalClose"
                     @updated="refresh"></AnswerModal>
        <CancelModal v-model="activeItemId" :show.sync="showCancel" @onClose="onModalClose"
                     @updated="refresh"></CancelModal>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Store from '@/store/store';
    import { CoordinationStatus } from '@/models/enums';
    import BtnsTemplate from '@/components/grid/StandardBtnsTemplate';
    import CreateModal from '@/components/coordinations/create.modal';
    import EditModal from '@/components/coordinations/edit.modal';
    import DisplayModal from '@/components/coordinations/display.modal';
    import AnswerModal from '@/components/coordinations/answer.modal';
    import CancelModal from '@/components/coordinations/cancel.modal';
    import CoordinationService from '@/services/coordinations.service';
    import { mapGetters } from 'vuex';
    import CreateSignatureModal from '@/components/coordinations/createSignature.modal';
    import CustomTabs from '@/components/tab/CustomTabs';

    Vue.use(CustomTabs);

    kendo.pdf.defineFont({
        'DejaVu Sans': 'https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans.ttf',
        'DejaVu Sans|Bold': 'https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Bold.ttf',
        'DejaVu Sans|Bold|Italic': 'https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf',
        'DejaVu Sans|Italic': 'https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/DejaVu/DejaVuSans-Oblique.ttf',
        WebComponentsIcons: 'https://kendo.cdn.telerik.com/2019.2.619/styles/fonts/glyphs/WebComponentsIcons.ttf'
    });

    export default {
        components: {
            CreateSignatureModal,
            CreateModal,
            EditModal,
            DisplayModal,
            AnswerModal,
            CancelModal
        },
        data() {
            return {
                assignedToMeTransportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + '/api/coordinations/AssignTo',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                createdByMeTransportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + '/api/coordinations/AssignBy',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                agreedByMeTransportSettings: {
                    read: {
                        url: this.$store.getters.baseUrl + '/api/coordinations/AgreedBy',
                        dataType: 'json',
                        type: 'POST',
                        contentType: 'application/json',
                        beforeSend: this.beforeSend
                    },
                    parameterMap: this.parameterMap
                },
                showEdit: false,
                showDisplay: false,
                showAnswer: false,
                showCancel: false,
                activeItem: null,
                activeItemId: null,
                defaultGridRows: this.$store.getters.defaultGridRows,
                showCreateSignatureModal: false
            };
        },
        methods: {
            onDatabound(e) {
                var items = e.sender.items();
                items.each(function (idx, item) {
                    let dataItem = e.sender.dataItem(item);
                    if (dataItem.statusId === CoordinationStatus.started) {
                        if (dataItem.coordinatorsTurn === Store.getters.userId) {
                            $(item).addClass('left-border-blue');
                        }
                    }
                });
            },
            onChange(data) {
                // parse date field in the grid data
                data.items.forEach(item => {
                    item.deadline = new Date(item.deadline);
                    item.createdOn = new Date(item.createdOn);
                });
            },
            parameterMap: function (options, operation) {
                if (operation !== 'read' && options.models) {
                    return { models: kendo.stringify(options.models) };
                } else {
                    return kendo.stringify(options);
                }
            },
            beforeSend: function (req) {
                if (this.token) {
                    req.setRequestHeader('Authorization', 'Bearer ' + this.token);
                }
            },
            btnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        // parentComponent: this.$refs.createdByMeGrid,
                        btns: [
                            {
                                name: 'start',
                                text: '',
                                tooltip: this.$t('coordinations.start'),
                                class: 'btn btn-success',
                                icon: 'fas fa-play',
                                show: e.statusId === CoordinationStatus.new && this.claims.tasks.update,
                                clickHandler: this.onStartClick
                            },
                            {
                                name: 'edit',
                                text: '',
                                tooltip: this.$t('buttons.edit.tooltipText'),
                                class: 'btn btn-success',
                                icon: 'fas fa-edit',
                                show: e.statusId === CoordinationStatus.new && this.claims.tasks.update,
                                clickHandler: this.showEditModal
                            },
                            {
                                name: 'details',
                                text: '',
                                tooltip: this.$t('buttons.details.tooltipText'),
                                class: 'btn btn-info',
                                icon: 'fas fa-eye',
                                show: this.claims.tasks.read,
                                clickHandler: this.showDisplayModal
                            },
                            {
                                name: 'export',
                                text: '',
                                tooltip: this.$t('buttons.export.tooltipText'),
                                class: 'btn btn-info',
                                icon: 'fas fa-print',
                                show: this.claims.tasks.read && (e.statusId === CoordinationStatus.started || e.statusId === CoordinationStatus.completed),
                                clickHandler: this.exportCoordination
                            },
                            {
                                name: 'cancel',
                                text: '',
                                tooltip: this.$t('coordinations.cancel'),
                                class: 'btn btn-info',
                                icon: 'fas fa-ban',
                                show: this.claims.tasks.update && e.statusId === CoordinationStatus.started,
                                clickHandler: this.onCancel
                            },
                            {
                                name: 'delete',
                                text: '',
                                tooltip: this.$t('buttons.delete.tooltipText'),
                                class: 'btn btn-danger',
                                icon: 'fas fa-trash',
                                show: e.statusId === CoordinationStatus.new && this.claims.tasks.delete,
                                clickHandler: this.onDelete
                            },
                            {
                                name: 'startSigningTask',
                                text: '',
                                tooltip: this.$t('tasks.createNewSingingTask'),
                                class: 'btn btn-success',
                                icon: 'fas fa-file-signature',
                                show: e.statusId === CoordinationStatus.completed,
                                clickHandler: this.onCreateNewSingingTask
                            },
                        ]
                    }
                };
            },
            assignToMeBtnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        // parentComponent: this.$refs.createdByMeGrid,
                        btns: [
                            {
                                name: 'answer',
                                text: '',
                                tooltip: this.$t('coordinations.answer'),
                                class: 'btn btn-info',
                                icon: 'fas fa-edit',
                                show:
                                    this.claims.tasks.update &&
                                    e.statusId === CoordinationStatus.started &&
                                    e.coordinatorsTurn === this.$store.getters.userId,
                                clickHandler: this.showAnswerModal
                            },
                            {
                                name: 'details',
                                text: '',
                                tooltip: this.$t('buttons.details.tooltipText'),
                                class: 'btn btn-info',
                                icon: 'fas fa-eye',
                                show: this.claims.tasks.read,
                                clickHandler: this.showDisplayModal
                            }
                        ]
                    }
                };
            },
            agreedToMeBtnsTemplate: function (e) {
                return {
                    template: Vue.component(BtnsTemplate.name, BtnsTemplate),
                    templateArgs: {
                        ...e,
                        // parentComponent: this.$refs.createdByMeGrid,
                        btns: [
                            {
                                name: 'details',
                                text: '',
                                tooltip: this.$t('buttons.details.tooltipText'),
                                class: 'btn btn-info',
                                icon: 'fas fa-eye',
                                show: this.claims.tasks.read,
                                clickHandler: this.showDisplayModal
                            },
                            {
                                name: 'export',
                                text: '',
                                tooltip: this.$t('buttons.export.tooltipText'),
                                class: 'btn btn-info',
                                icon: 'fas fa-print',
                                show: this.claims.tasks.read && (e.statusId === CoordinationStatus.started || e.statusId === CoordinationStatus.completed),
                                clickHandler: this.exportCoordination
                            },
                        ]
                    }
                };
            },
            refresh() {
                this.$refs['createdByMeGrid'].kendoWidget().dataSource.read();
                this.$refs['assignedToMeGrid'].kendoWidget().dataSource.read();
            },
            exportCoordination(args) {
                this.$http
                    .get('/api/coordinations/pdfExport/' + args.id, { responseType: 'blob' })
                    .then(response => {
                        const blob = new Blob([response.data], { type: 'application/pdf' });
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'Coordination.pdf'); // or any other extension
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch(error => {
                        this.$vs.notify({
                            title: this.$t('request.response.status.' + this.$helpers.errorStatusCode(error)),
                            text: this.$helpers.errorText(error),
                            color: 'danger',
                            time: this.$store.getters.notificationDuration
                        });
                    });
            },
            showEditModal(item) {
                this.activeItem = { ...item };
                this.showEdit = true;
            },
            showDisplayModal(item) {
                this.activeItem = { ...item };
                this.showDisplay = true;
            },
            showAnswerModal(item) {
                this.activeItem = { ...item };
                this.showAnswer = true;
            },
            onModalClose() {
                this.activeItemId = null;
                this.activeItem = null;
                this.showCreateSignatureModal = false;
            },
            onStartClick(e) {
                this.startId = e.id;
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'success',
                    title: this.$t('coordinations.startTitle'),
                    text: this.$t('coordinations.startMessage'),
                    accept: this.startCoordination,
                    acceptText: this.$t('buttons.ok'),
                    cancelText: this.$t('buttons.cancel'),
                    cancel: () => (this.startId = null)
                });
            },
            startCoordination() {
                CoordinationService.start(this.startId)
                    .then(() => {
                        this.$vs.notify({
                            color: 'success',
                            title: this.$t('updateSuccess'),
                            text: ''
                        });
                        this.refresh();
                    })
                    .catch(err =>
                        this.$vs.notify({
                            color: 'danger',
                            title: this.$t('notifications.error'),
                            text: this.$helpers.errorText(err)
                        })
                    )
                    .then(() => (this.startId = null));
            },
            onCancel(e) {
                this.activeItemId = e.id;
                this.showCancel = true;
            },
            onDelete(e) {
                this.deleteId = e.id;
                this.$vs.dialog({
                    type: 'confirm',
                    color: 'danger',
                    title: this.$t('tasks.deletion'),
                    text: this.$t('coordinations.deletionConfirmMessage'),
                    accept: this.deleteTask,
                    acceptText: this.$t('buttons.ok'),
                    cancelText: this.$t('buttons.cancel'),
                    cancel: () => (this.deleteId = null)
                });
            },
            deleteTask() {
                CoordinationService.delete(this.deleteId)
                    .then(() => {
                        this.$vs.notify({
                            color: 'success',
                            title: this.$t('deleteSuccess'),
                            text: ''
                        });
                        this.refresh();
                    })
                    .catch(err =>
                        this.$vs.notify({
                            color: 'danger',
                            title: this.$t('notifications.error'),
                            text: this.$t('notifications.serverError')
                        })
                    )
                    .then(() => (this.deleteId = null));
            },
            showCoordination(taskId) {
                this.$http
                    .get('/api/coordinations/get/' + taskId)
                    .then(response => {
                        this.showDisplayModal(response.data);
                    })
                    .catch(err => {
                        this.$vs.notify({
                            color: 'danger',
                            title: this.$t('notifications.error'),
                            text: this.$helpers.errorText(err)
                        });
                    });
            },
            onCreateNewSingingTask(e) {
                this.activeItemId = e.id;
                $('#createSigningFromCoordinationModal').modal('show');
                this.showCreateSignatureModal = true;
            },
            answerCoordination(taskId) {
                this.$http
                    .get('/api/coordinations/get/' + taskId)
                    .then(response => {
                        if (response.data) {
                            if (response.data.statusId !== CoordinationStatus.started) {
                                this.showDisplayModal(response.data);
                            } else if (response.data.coordinatorsTurn === this.userId) {
                                this.showAnswerModal(response.data);
                            } else {
                                this.$vs.notify({
                                    color: 'danger',
                                    title: this.$t('notifications.error'),
                                    text: this.$t('coordinations.notYourTurn')
                                });
                            }
                        } else {
                            this.$vs.notify({
                                color: 'danger',
                                title: this.$t('notifications.error'),
                                text: this.$t('coordination.notFound')
                            });
                        }
                    })
                    .catch(err => {
                        this.$vs.notify({
                            color: 'danger',
                            title: this.$t('notifications.error'),
                            text: this.$helpers.errorText(err)
                        });
                    });
            }
        },
        computed: {
            token: function () {
                return this.$store.getters.authToken;
            },
            ...mapGetters(['claims', 'userId', 'gridOptions'])
        },
        mounted() {
            if (this.$route.query['view'] || this.$route.query['answer']) {
                var taskId = this.$route.query['view'] || this.$route.query['answer'];

                if (this.$route.query['view']) {
                    this.showCoordination(taskId.trim());
                } else {
                    this.answerCoordination(taskId.trim());
                }
            }
        }
    };
</script>

<style lang="scss" scoped></style>
